import { FunctionComponent } from "react";

interface RoutingRangeValuesProps {
	from: number | null;
	to: number | null;
	onChange: (range: { from: number | null; to: number | null }) => void;
	fromLabel: string;
	toLabel: string;
}

const toBound = (text: string): number | null => {
	const value = Number.parseInt(text, 10);

	return Number.isFinite(value) && value >= 0 ? value : null;
};

/** The from/to employee counts of a "Number of employees is between" condition. */
export const RoutingRangeValues: FunctionComponent<RoutingRangeValuesProps> = ({
	from,
	to,
	onChange,
	fromLabel,
	toLabel,
}) => (
	<div className="flex items-center gap-2">
		<input
			aria-label={fromLabel}
			className="w-24 rounded-md border border-border-light px-2 py-1 text-sm"
			min={0}
			placeholder={fromLabel}
			type="number"
			value={from ?? ""}
			onChange={(event) => onChange({ from: toBound(event.target.value), to })}
		/>
		<span className="text-xs text-text-meta">–</span>
		<input
			aria-label={toLabel}
			className="w-24 rounded-md border border-border-light px-2 py-1 text-sm"
			min={0}
			placeholder={toLabel}
			type="number"
			value={to ?? ""}
			onChange={(event) => onChange({ from, to: toBound(event.target.value) })}
		/>
	</div>
);
